import SectionTitle from "./SectionTitle";

const week = [
  { day: "周一", items: ["校园异能日记", "雾都档案"] },
  { day: "周二", items: ["都市传说档案", "山海食堂"] },
  { day: "周三", items: ["星辰炼金师", "千夜物语"] },
  { day: "周四", items: ["拳道少年", "时之砂"] },
  { day: "周五", items: ["星际冒险队", "纸牌屋侦探"] },
  { day: "周六", items: ["逆世剑主", "御风少年"] },
  { day: "周日", items: ["治愈系小森林", "月光甜品屋"] },
];

export default function Calendar() {
  return (
    <section id="calendar" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <SectionTitle
              align="left"
              eyebrow="追更日历"
              title="更新安排，一眼看全"
              desc="追更日历把你在追的所有作品整理成清晰的更新表，按周展示每部作品的预计更新时间。新增章节会自动点亮提醒，更新状态随时掌握，再也不必手动记日子。"
            />
            <ul className="mt-8 space-y-4">
              <li className="flex gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-calendar-check-line"></i>
                </span>
                <p className="text-sm leading-6 text-foreground-600">
                  <strong className="font-semibold text-foreground-900">按周整理</strong>
                  ，同一作品多部连载也能清晰归位，更新节奏一目了然。
                </p>
              </li>
              <li className="flex gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-flashlight-line"></i>
                </span>
                <p className="text-sm leading-6 text-foreground-600">
                  <strong className="font-semibold text-foreground-900">更新点亮</strong>
                  ，当天有新章节的作品会高亮提醒，第一时间关注。
                </p>
              </li>
              <li className="flex gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                  <i className="ri-check-double-line"></i>
                </span>
                <p className="text-sm leading-6 text-foreground-600">
                  <strong className="font-semibold text-foreground-900">阅读联动</strong>
                  ，阅读后自动标记，已读与未读一眼分辨。
                </p>
              </li>
            </ul>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-5">
            <div className="mb-4 flex items-center justify-between">
              <h3 className="font-heading text-lg text-foreground-950">本周追更安排</h3>
              <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                <i className="ri-refresh-line"></i>
                自动同步
              </span>
            </div>
            <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2">
              {week.map((d) => (
                <div key={d.day} className="rounded-lg border border-background-200 bg-background-50 p-3">
                  <p className="text-xs font-bold text-primary-600">{d.day}</p>
                  <ul className="mt-2 space-y-1.5">
                    {d.items.map((it) => (
                      <li key={it} className="flex items-center justify-between text-sm text-foreground-700">
                        <span>{it}</span>
                        <i className="ri-check-line text-secondary-500"></i>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}